export const FrontendRoutes = {
  INDEX: "/",
  LEAFLET_LOCATION: "/leaflet/location/:id",
  NOT_FOUND: "/*"
};
